import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { validateField } from "../../contexts/Utils";
import {
  EditPartApi,
  GetAllUnits,
  GetAllCategories,
  GetAllSalesCategories,
  GetAllPNStatus,
  GetPartById,
} from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";

const EditPart = () => {
  const navigate = useNavigate();
  let param = useParams();
  const { userID } = useStateContext();
  const part_id = param.p_id;
  const fileInputRef = useRef(null);
  const [getscategorys, setSCategorys] = useState([]);
  const [getunits, setUnits] = useState([]);
  const [getcategories, setCategories] = useState([]);
  const [getpnstatus, setPNStatus] = useState([]);
  const getReasonOptions = [
    { value: 704, label: "Change to Description, No Inv change" },
    { value: 705, label: "Change to Location, No Inv change" },
    { value: 706, label: "Change to Price, No Inv change" },
  ];
  const [formData, setFormData] = useState({
    part_number: "",
    company: "Select Company",
    description: "",
    category: "Select Category",
    sales_category: "Select Sales Category",
    unit: "Select Unit",
    location: "",
    cost_price: "0.0",
    sale_price: "0.0",
    markup: "0.0",
    status: "Select Status",
    serialized: false,
    image: { id: 1, file: null, preview: null },
    pn_note: "",
    reason: "Select Reason",
    reason_note: "",
  });
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Part");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "cost_price" || name === "sale_price" || name === "markup") {
      var cost = parseFloat(formData.cost_price);
      var sale = parseFloat(formData.sale_price);
      var mark = parseFloat(formData.markup);
      if (name === "cost_price") {
        if (value && sale !== null)
          setFormData((prev) => ({
            ...prev,
            [name]: value,
            markup: (((sale - value) * 100) / value).toFixed(6),
          }));
        else if (value && mark !== null)
          setFormData((prev) => ({
            ...prev,
            [name]: value,
            sale_price: ((mark * value) / 100 + value).toFixed(6),
          }));
      } else if (name === "sale_price" && value && cost !== null)
        setFormData((prev) => ({
          ...prev,
          [name]: value,
          markup: (((value - cost) * 100) / cost).toFixed(6),
        }));
      else if (name === "markup" && value && cost !== null)
        setFormData((prev) => ({
          ...prev,
          [name]: value,
          sale_price: (cost + (value * cost) / 100).toFixed(6),
        }));
      else setFormData((prev) => ({ ...prev, [name]: value }));
    } else setFormData((prev) => ({ ...prev, [name]: value }));

    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleChangeSerial = () => {
    const serr = formData.serialized;
    setFormData((prev) => ({ ...prev, serialized: serr ? false : true }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "select" }));
  };

  const handleImgChange = (e, imageID, fInput) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 1048576) {
        fInput.current = null;
        alert("Image File max size is 1 MB!");
        setFormData((prev) => ({
          ...prev,
          image: { id: 1, file: null, preview: null },
        }));
        e.target.value = null;
        return;
      } else {
        setFormData((prev) => ({
          ...prev,
          image: {
            id: 1,
            file: file,
            preview: file ? URL.createObjectURL(file) : null,
          },
        }));
      }
    }
  };

  // const handleRemoveImage = (id, fInput) => {
  //   fInput.current = null;
  //   setFormData((prev) => ({
  //     ...prev,
  //     image: { id: 1, file: null, preview: null },
  //   }));
  // };

  const bufferToBase64 = (buffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const chunkSize = 0x8000; // 32KB chunks
    for (let i = 0; i < bytes.length; i += chunkSize) {
      const subarray = bytes.subarray(i, i + chunkSize);
      binary += String.fromCharCode.apply(null, subarray);
    }
    return btoa(binary);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    let img = null;
    if (formData?.image?.file) {
      const buffer = await formData.image.file.arrayBuffer();
      img = bufferToBase64(buffer);
    }
    try {
      const response = await EditPartApi(
        part_id,
        formData.category.value,
        formData.sales_category.value,
        formData.description,
        formData.unit.value,
        formData.location,
        formData.cost_price,
        formData.sale_price,
        formData.markup,
        formData.serialized,
        formData.status.value,
        formData.company.value,
        img,
        formData.pn_note,
        formData.reason.value,
        formData.reason_note,
        userID,
      );
      if (response.success) {
        showSuccessToast("Success!", "Part updated successfully!");
        navigate("/Part");
      } else
        showErrorToast("Error!", "Part update failed!\n\n" + response.message);
    } catch (err) {
      showErrorToast("Error!", "Part update failed!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      if (part_id) {
        TimeoutUtility.resetTimeout();
        await GetAllCategories()
          .then((resp) => {
            const categOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.category_id,
            }));
            setCategories(categOptions || []);
          })
          .catch((err) => console.log(err.message));
        await GetAllSalesCategories()
          .then((resp) => {
            const typeOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.sales_category_id,
            }));
            setSCategorys(typeOptions || []);
          })
          .catch((err) => console.log(err.message));
        await GetAllUnits()
          .then((resp) => {
            const unitOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.unit_id,
            }));
            setUnits(unitOptions || []);
          })
          .catch((err) => console.log(err.message));
        await GetAllPNStatus()
          .then((resp) => {
            const statsOptions = resp.data.map((item) => ({
              label: item.name,
              value: item.pn_status_id,
            }));
            setPNStatus(statsOptions || []);
          })
          .catch((err) => console.log(err.message));
        await GetPartById(part_id)
          .then((result) => {
            setFormData({
              part_number: result.data.part_number,
              company: {
                label: result.data.company,
                value: result.data.company_id,
              },
              description: result.data.description || "",
              category: {
                label: result.data.category,
                value: result.data.category_id,
              },
              sales_category: {
                label: result.data.s_category,
                value: result.data.s_category_id,
              },
              unit: { label: result.data.unit, value: result.data.unit_id },
              location: result.data.stockroom_location || "",
              cost_price: result.data.cost_price || "0.0",
              sale_price: result.data.sale_price || "0.0",
              markup: result.data.mark_up || "0.0",
              status: {
                label: result.data.pn_status,
                value: result.data.pn_status_id,
              },
              serialized: result.data.serialized,
              image: {
                id: 1,
                file: null,
                preview: result.data.image
                  ? "data:image/jpeg;base64," + result.data.image
                  : null,
              },
              pn_note: result.data.pn_note || "",
            });
          })
          .catch((err) => console.log(err.message));
      }
    }
    fetchData();
  }, [part_id]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="EDIT PART" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={4} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="Part Number:"
                  name="part_number"
                  value={formData.part_number}
                  placeholder="Part Number"
                  disabled
                />
                {/* <SelectField
                  label="Company:"
                  name="company"
                  value={formData.company}
                  placeholder="Company"
                  compulsory={true}
                  isDisabled
                /> */}
                <TextAreaField
                  label="Description:"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Part Description"
                  compulsory={true}
                  error={errors.description}
                />
                <SelectField
                  label="Category:"
                  name="category"
                  value={formData.category}
                  options={getcategories}
                  onChange={handleSelectChange}
                  placeholder="Category"
                  compulsory={true}
                  error={errors.category}
                />
                <SelectField
                  label="Sales Category:"
                  name="sales_category"
                  value={formData.sales_category}
                  options={getscategorys}
                  onChange={handleSelectChange}
                  placeholder="Sales Category"
                  compulsory={true}
                  error={errors.sales_category}
                />
                <SelectField
                  label="Unit:"
                  name="unit"
                  value={formData.unit}
                  options={getunits}
                  onChange={handleSelectChange}
                  placeholder="Unit"
                  compulsory={true}
                  error={errors.unit}
                />
                <TextInputField
                  label="Stockroom Location:"
                  name="location"
                  value={formData.location}
                  onChange={handleChange}
                  placeholder="Stockroom Location"
                  error={errors.location}
                />
              </div>
            </Col>
            <Col md={4} className="container-col">
              <div className="col-lg-12">
                <DoubleField
                  label="Cost Price:"
                  name="cost_price"
                  value={formData.cost_price}
                  onChange={handleChange}
                  placeholder="Cost Price"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.cost_price}
                />
                <DoubleField
                  label="Sale Price:"
                  name="sale_price"
                  value={formData.sale_price}
                  onChange={handleChange}
                  placeholder="Sale Price"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.sale_price}
                />
                <DoubleField
                  label="Markup %:"
                  name="markup"
                  value={formData.markup}
                  onChange={handleChange}
                  placeholder="Markup"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.markup}
                />
                <SelectField
                  label="PN Status:"
                  name="status"
                  value={formData.status}
                  options={getpnstatus}
                  onChange={handleSelectChange}
                  placeholder="PN Status"
                  compulsory={true}
                  error={errors.status}
                />
                <div className="form-group mt-3">
                  <label className="label">Serialized:</label>
                  <input
                    type="checkbox"
                    className="input"
                    name="serialized"
                    checked={formData.serialized}
                    onChange={handleChangeSerial}
                  />
                </div>
                <TextAreaField
                  label="Notes:"
                  name="pn_note"
                  value={formData.pn_note}
                  onChange={handleChange}
                  placeholder="Part Notes"
                  error={errors.pn_note}
                />
              </div>
            </Col>
            <Col md={4} className="container-col">
              <div className="col-lg-12 container-video-div">
                <div className="mt-10 w-100 flex flex-col">
                  {formData?.image?.preview && (
                    <img
                      src={formData?.image?.preview || null}
                      className="container-image"
                      alt={`Part ${formData?.image?.id}`}
                    />
                  )}
                  <div className="flex justify-left mt-4">
                    <div>
                      <label
                        className="label"
                        htmlFor={`imageInput${formData?.image?.id}`}
                      >{`Image:`}</label>
                      <input
                        ref={fileInputRef}
                        className="product-image-input"
                        type="file"
                        id={`imageInput${formData?.image?.id}`}
                        accept="image/*"
                        onChange={(e) =>
                          handleImgChange(e, formData?.image?.id, fileInputRef)
                        }
                      />
                    </div>
                    {/* {formData?.image?.preview && (
                      <button
                        type="button"
                        onClick={(e) =>
                          handleRemoveImage(formData?.image?.id, fileInputRef)
                        }
                      >
                        ❌
                      </button>
                    )} */}
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={6} className="container-col">
              <SelectField
                label="Reason for Update:"
                name="reason"
                value={formData.reason}
                options={getReasonOptions}
                onChange={handleSelectChange}
                placeholder="Reason for Update"
                compulsory={true}
                error={errors.reason}
              />
              <TextAreaField
                label="Reason Note:"
                name="reason_note"
                value={formData.reason_note}
                onChange={handleChange}
                placeholder="Reason Note"
                error={errors.reason_note}
              />
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Update"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default EditPart;
